<template>
  <Card>  
    <template #cardBody>
      <div class="d-flex justify-content-end align-items-center mb-3">
        <Button v-if="$can(abilities.CAN_ADD_PARTICIPANT_TO_EVENT)"
            type="new"
            @click.prevent="openCreateParticipatorModal"
            btn-class="btn-sm me-2" btn-text="events.participator.create" />

        <Button v-if="$can(abilities.CAN_ADD_PARTICIPANT_TO_EVENT)"
            type="new"
            @click.prevent="openAskBookModal"
            btn-class="btn-sm me-2" btn-text="events.participator.askBook" />

        <Button v-if="$can(abilities.CAN_CREATE_PARTICPANT_STATUT)"
            type="new"
            @click.prevent="openAddStatusModal"
            btn-class="btn-sm me-2" btn-text="events.participator.addState" />
     
        <Button @click="openImportModal" v-if="$can(abilities.CAN_IMPORT_EVENT_PARTICIPANT) || $can(abilities.CAN_EXPORT_EVENT_PARTICIPANT)"
            type="new"
            btn-class="btn-sm me-2" btn-text="events.import_export" />
      </div>
      <div class="table-responsive row">
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
               id="event_participator_datatable">
          <thead class="mb-5">
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th class="min-w-100px text-center">{{ $t('events.label.fullName') }}</th>
            <th class="min-w-100px text-center">{{ $t('events.label.email') }}</th>
            <th class="min-w-100px text-center">{{ $t('events.label.phone') }} </th>
            <th class="min-w-100px text-center">{{ $t('events.label.status') }} </th>
            <th class="w-100px text-start">{{ $t('label.action') }}</th>
          </tr>
          </thead>
        </table>
      </div>
    </template>
  </Card>

  <AddParticipatorModal id="addParticipatorModal" :event-id="route.params.id" @created="reloadData" />
  <UpdateParticipatorModal :form="formEdit" id="edit_participator" :event-id="route.params.id" @updated="reloadData" />

  <AddStatusModal id="addParticipatorStatusModal" :event-id="route.params.id" @created="reloadData" /> 
  <AskForBook id="askForBook" :event-id="route.params.id" />

  <div class="modal fade" id="export_import_modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="importParticipators" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.import_export') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="openImportModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <Button v-if="$can(abilities.CAN_EXPORT_EVENT_PARTICIPANT)" btn-class="btn-md mb-5 w-100" type="new" iconClass="fas fa-file-export me-2" btn-text="events.export" @click="exportParticipators" :is-loading="isLoadingExport"></Button>
            <Button v-if="$can(abilities.CAN_IMPORT_EVENT_PARTICIPANT)" btn-class="btn-md mb-5 w-100" type="new" iconClass="fas fa-download me-2" btn-text="events.download_model" @click="downloadExcel" :is-loading="isLoadingDownload"></Button>
            <InputFileIcon
              v-if="$can(abilities.CAN_IMPORT_EVENT_PARTICIPANT)"
                containerClass="col-12"
                :name="`events-import`"
                :label="$t('events.enter_import_partcipator_file')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="true"
                size="lg"
                :placeholder="$t('events.participators')"
                v-model="formImportParticipator.file"
            />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="openImportModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingImportParticipators"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>

import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import Ls from "@/services/ls";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {BASE_URL} from "@/services/api";
import i18n from "@/plugins/i18n";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import {useSwal} from "@/composables/useSwal";
import Button from "@/components/Button.vue";
import {useStore} from "vuex";
import AddStatusModal from "@/Modules/Events/components/modals/AddStatusModal.vue";
import AskForBook from "@/Modules/Events/components/modals/AskForBook.vue";
import {useRoute} from "vue-router";
import {useEventEnums} from "@/Modules/Events/composables/eventTypes";
import AddParticipatorModal from "@/Modules/Events/components/modals/AddParticipatorModal.vue";
import { Theme } from "@/composables/theming";
import UpdateParticipatorModal from "@/Modules/Events/components/modals/UpdateParticipatorModal.vue";
import InputFileIcon from "@/components/InputFileIcon"

const route = useRoute()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()
const { showSwal } = useSwal() 
const { inscriptionStatus } = useEventEnums()

const table = ref(null)

const formEdit = ref({
  gender: '',
  email: '',
  phone: '',
  phone_code: '',
  company: '',
  sector: '',
  post: '',
  firstname: '',
  lastname: '',
  event_id: '',
  type: '',
  status_id: '' 
})


const isLoadingImportParticipators = ref(false)
const isLoadingDownload = ref(false)
const isLoadingExport = ref(false)
const formImportParticipator = ref({
  event_id: '',
  file: null
})

const eventStatus = computed(() => store.getters['events/getEventStatus'])

watch(() => route.query.tab, (value) => {
  if(value) {
    loadData()
    loadEventParticipators()
  }
});

function loadEventParticipators() {
  if(can(abilities.VIEW_EVENT_PARTICIPATORS) && route.query.tab === 'tab-participators') {
    const AUTH_TOKEN = Ls.get('auth.token')

    table.value = $('#event_participator_datatable').DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: Ls.get('pageLength') ?? 5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 1, 'desc']],
      ajax: {
        url: BASE_URL + `/get/validated/event/${route.params.id}/invitations/datatables?invitation_status=${inscriptionStatus.value.APPROVED}`,
        type: "GET",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        }
      },
      columns: [
        { data: "id" }, { data: "email" }, { data: "phone" }, { data: "status_id" },{ data: "Actions", responsivePriority: -1 }
      ],
      columnDefs: [
        {
          targets: -5,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + e.firstname + ' ' + e.lastname + "</span>";
          },
        },

        {
          targets: -4,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },
        {
          targets: -3,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + e.phone_code + ' ' + e.phone + "</span>";
          }
        },

        {
          targets: -2,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {

            let options = '';
            eventStatus.value.forEach(status => {
              options += `
                  <option value="${status.id}" ${status.id === t ? 'selected' : ''}>
                    ${status.name}
                  </option>`;
            });

            return `
              <div class="d-flex justify-content-center me-2">
                <select style="background-color: var(--bs-primary)!important;color: white;border-radius: 8px;border: none;padding: 0.4rem 0.75rem;"
                class="form-select form-select-sm fw-bold participator-status-selector w-150px" data-participator="${e.id}"
                        onchange="updateParticipatorStatus(this.dataset.participator, this.value)">
                  ${options}
                </select>
              </div>
            `;
          }
        },
        {
        width: "15%",
        targets: -1,
        "className": "dt-center text-start",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => { 
          let render=""
          if(can(abilities.CAN_UPDATE_EVENT_PARTICIPANT)){
            render += `
                <a href="javascript:;" 
                data-id="${e.id}" 
                data-gender="${e.gender}" 
                data-email="${e.email}" 
                data-phone="${e.phone}" 
                data-phone_code="${e.phone_code}" 
                data-company="${e.company}" 
                data-sector="${e.sector}" 
                data-post="${e.post}" 
                data-firstname="${e.firstname}" 
                data-lastname="${e.lastname}" 
                data-type="${e.type}" 
                data-status="${e.status_id}" 
                class="btn btn-sm btn-icon edit_btn"
                    title="${i18n.global.t('button.edit')}" style="color: ${Theme.gray}">
                    <i class="fas fa-edit fs-1"
                     data-id="${e.id}" 
                      data-gender="${e?.gender}" 
                      data-email="${e.email}" 
                      data-phone="${e?.phone}" 
                      data-phone_code="${e?.phone_code}" 
                      data-company="${e?.company}" 
                      data-sector="${e?.sector}" 
                      data-post="${e?.post}" 
                      data-firstname="${e.firstname}" 
                      data-lastname="${e.lastname}" 
                      data-type="${e?.type}" 
                      data-status="${e?.status_id}"
                    ></i>
                </a>
            `;
          }
          render += `
                <a href="javascript:;" 
                  data-id="${e.id}" 
                  class="btn btn-sm btn-icon send_btn"
                  title="${i18n.global.t('button.send')}" style="color: ${Theme.gray}">
                  <i class="far fa-paper-plane fs-1" data-id="${e.id}"></i>
                </a>
            `;
         
          return render
        },
      },

      ],
      language: {
        url: datatableLocaleUrl.value,
      }
    })

    $(document).on("click", "#event_participator_datatable .edit_btn", (e) => {
      formEdit.value.id = e.target.getAttribute('data-id') ?? ''
      formEdit.value.gender = e.target.getAttribute('data-gender') ?? ''
      formEdit.value.email = e.target.getAttribute('data-email') ?? ''
      formEdit.value.phone = e.target.getAttribute('data-phone') ? e.target.getAttribute('data-phone') : " "
      formEdit.value.phone_code = e.target.getAttribute('data-phone_code') ? e.target.getAttribute('data-phone_code') : null
      formEdit.value.company = e.target.getAttribute('data-company') ?? ''
      formEdit.value.sector = e.target.getAttribute('data-sector') ?? ''
      formEdit.value.post = e.target.getAttribute('data-post') ?? ''
      formEdit.value.lastname = e.target.getAttribute('data-lastname') ?? ''
      formEdit.value.firstname = e.target.getAttribute('data-firstname') ?? ''
      formEdit.value.event_id = route.params.id
      formEdit.value.type = e.target.getAttribute('data-type') ?? ''
      formEdit.value.status_id = e.target.getAttribute('data-status') ?? ''

      nextTick(() => {
        $('#edit_participator').modal('toggle')
      })
      
    });

    $(document).on("click", "#event_participator_datatable .send_btn", (e) => {
      let id = e.target.getAttribute('data-id') ?? ''
      sendEventParticipator(id)
    });
    $(document).on("click", "#event_participator_datatable .send_btn_first_relance", (e) => {
      let id = e.target.getAttribute('data-id') ?? ''
      sendParticipatorFirstRelance(id)
    });
    $(document).on("click", "#event_participator_datatable .send_btn_last_relance", (e) => {
      let id = e.target.getAttribute('data-id') ?? ''
      sendParticipatorLastRelance(id)
    });
  }

}

function sendParticipatorFirstRelance (id) {
  showSwal(
      i18n.global.t('events.swal.resend_relance_first'),
      i18n.global.t('events.swal.resend_first_relance_mail_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('events/sendParticipatorFirstRelance', id)
          .then(res => {

          })
          .catch(err => {

          })
    }
  })
}

function sendParticipatorLastRelance (id) {
  showSwal(
      i18n.global.t('events.swal.resend_relance_last'),
      i18n.global.t('events.swal.resend_last_relance_mail_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('events/sendParticipatorLastRelance', id)
          .then(res => {

          })
          .catch(err => {

          })
    }
  })
}
function sendEventParticipator(id){
  showSwal(
      i18n.global.t('events.swal.send_invitation'),
      i18n.global.t('events.swal.send_invitation_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('events/resendParticipator', {event_id: route.params.id, participator_id: id})
        .then(() => {
          window.toastr['success'](i18n.global.t('notifications.invitation_participator_resended'))
          table.value.ajax.reload()
        })
        .catch(() => {

        })
    }
  })
}

function loadData() {
  if(route.query.tab === 'tab-participators') {
    Promise.all([
      store.dispatch('countries/loadCountries'),
      store.dispatch('events/loadEventStatus'),
      store.dispatch('events/loadEventStatusEnum'),
      store.dispatch('events/loadEventParticipatorType'),
      store.dispatch('events/loadEventValidatedParticipators', route.params.id),
    ])
  }
}

function openAddStatusModal() {
  $('#addParticipatorStatusModal').modal('toggle');
}

function openCreateParticipatorModal() {
  $('#addParticipatorModal').modal('toggle');
}

function openImportModal() {
  $('#export_import_modal').modal('toggle')
}

function openAskBookModal(){
    $('#askForBook').modal('toggle')
}

function importParticipators() {
  isLoadingImportParticipators.value = true;
  formImportParticipator.value.event_id = route.params.id

  store
    .dispatch('events/importParticipators', formImportParticipator.value)
    .then(() => {
        isLoadingImportParticipators.value = false;
        loadEventParticipators()
        openImportModal()
        window.toastr["success"](i18n.global.t('events.import_participator_successfully'));
    })
    .catch((e) => {

        isLoadingImportParticipators.value = false;
    });
}

function exportParticipators() {
  isLoadingExport.value = true

  store
    .dispatch('events/exportParticipators', route.params.id)
    .then(() => {
        isLoadingExport.value = false;
        window.toastr["success"](i18n.global.t('events.export_participator_successfully'));
    })
    .catch((e) => {

        isLoadingExport.value = false;
    });
}

const downloadExcel = async () => {   
    try {
      isLoadingDownload.value = true
      store
      .dispatch('events/downloadParticipatorExcelModel')
      .then(async (resp) => {

        const url = window.URL.createObjectURL(new Blob([resp.data], { type: resp.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'PARTICIPANT_MODEL.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        isLoadingDownload.value = false;

  
      })
      .catch((e) => {

          isLoadingExport.value = false;
      });

    } catch (e) { }
    isLoadingDownload.value = false
} 

function reloadData() {
  store.dispatch('events/loadEventStatus')
      .finally(() => {
        table.value.ajax.reload()
      })
}

defineExpose({
  reloadParticipatorData: reloadData,
})

window.updateParticipatorStatus = function updateParticipatorStatus (participator, status) {
  if(can(abilities.CAN_UPDATE_EVENT_PARTICIPANT_STATUS)){
    const payload = {
      participator_id: participator,
      event_id: route.params.id,
      status_id: status
    }
    store.dispatch('events/changeParticipatorStatus', payload)
        .then(() => {
          reloadData()
        })
  }
  
}



onMounted(() => {
  loadData()
  loadEventParticipators()
})
</script>

<style scoped>
.participator-status-selector {
  background-color: var(--bs-primary)!important;
  color: white;
  border-radius: 8px;
  border: none;
  padding: 0.4rem 0.75rem;
}
</style>